export const formatFileSize = (size) => {
  if (size < 1024) {
    return `${size} B`; // Bytes
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`; // Kilobytes
  } else if (size < 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`; // Megabytes
  } else {
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`; // Gigabytes
  }
};
